import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-login',
    // templateUrl: './login.component.html',
    template: '',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
    constructor(
        private router: Router,
        /*         private loginService: LoginService,
                 private accountService: AccountService,
                 private stateStorageService: StateStorageService,
                 private messageService: MessageService */) {
        /*     const navigation = this.router.getCurrentNavigation();
         const state = navigation?.extras?.state as { message: string } | undefined;
         this.state = state;*/
    }

    login: string;
    password: string;
    state: { message: string };

    ngOnInit(): void {
        this.router.navigate(['h']);
        /*
        if (this.state?.message === 'logout') {
            setTimeout(() => this.messageService.add({severity: 'success', summary: 'Succès', detail: 'Déconnection avec succès'}));
        } else if (this.state?.message === 'login') {
            setTimeout(() => this.messageService.add({severity: 'error', summary: 'Erreur', detail: 'Vous devez vous connecter pour accéder à cette page'}));
        } else {
            this.accountService.identity().then((el) => {
                if(el) this.router.navigate(['/h']);
            })
        }*/

    }

    /*
        async loggin() {
            this.loginService.login({
                username: this.login,
                password: this.password,
            })
            .then(() => {
                //this.dmpWebsocketService.connect();
                // TODO: check if we need to reimplment DmpWebsocketService
                const redirect = this.stateStorageService.getUrl();
                if (redirect) {
                    this.stateStorageService.storeUrl(null);
                    this.router.navigateByUrl(redirect);
                } else {
                    this.router.navigate(['h']);
                }
            }).catch(() => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: `Nom d'utilisateur ou mot de passe incorrect`})
            })
        } */
}
